import React from 'react';
import { createMaskedInput } from './MaskedInput';
import { AdornedInput } from '@zillow/constellation-10';
import { getNumberFromString } from '../../utils/formatters';

function removeDollarSign(value: string) {
  return value.replace('$', '');
}

function addDollarSign(value: string) {
  value = removeDollarSign(value).trim();
  if (!value) return '';
  return `$${value}`;
}

const MaskedCurrencyInputComponent = createMaskedInput(
  {
    mask: 'num',
    blocks: {
      num: {
        mask: Number,
        thousandsSeparator: ',',
        radix: '.',
        scale: 2,
        padFractionalZeros: true,
        normalizeZeros: true,
      },
    },
    type: 'text',
    inputMode: 'numeric',
  },
  removeDollarSign,
  addDollarSign,
);

export const MaskedCurrencyInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof MaskedCurrencyInputComponent>
>(function MaskedCurrencyInput(props, ref) {
  return (
    <AdornedInput.Root>
      <AdornedInput.Adornment>$</AdornedInput.Adornment>
      <MaskedCurrencyInputComponent ref={ref} isAdorned {...props} />
      <AdornedInput.Adornment>/month</AdornedInput.Adornment>
    </AdornedInput.Root>
  );
});

// The api refuses a larger amount, and its error names no form field, so keep it out of saveAnswers
const MAX_AMOUNT = 9_999_999_999_999.99;

export const validateCurrency = (value: string) => {
  const amount = getNumberFromString(value);
  if (amount <= 0) {
    return 'Amount must be greater than $0';
  }
  if (amount > MAX_AMOUNT) {
    return 'Enter a smaller amount';
  }
  return true;
};
